import { TiTick } from "react-icons/ti";
import bannerImg from '../../assets/images/team-working-on-mobile-app-project.avif'
import {Banner, SpecializedSEOServices,IndustriesWeEmpower, ReadyToDominate, SEOProcess,Faq} from './components'
function SearchEngineOptimization() {
  return (
      <section className="space-y-20 md:space-y-32 mb-20 md:mb-32">
    <Banner/>
    <SpecializedSEOServices/>
    <ReadyToDominate/>
    <IndustriesWeEmpower /> 
    {/* <SEOProcess/> */}
    <Faq/>
    </section>
  );
}
export default SearchEngineOptimization;
